import { ColumnModel } from "../api/api.models"

import { ConvertHelper } from '../../helpers/convert-helper'
import { LocalizationHelper } from "../../helpers/localization-helper"
import { ToastHelper } from '../../helpers/toast-helper'

import { Enums } from "../../models/common/enums"
import { OpAlarmEvent } from '../../models/dw/op-alarm-event'


export class AlarmHelper {

    // Consts

    public static get FILE_NAME_PREFIX(): string { return 'alarms' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType  { return Enums.ReferenceType.IdAlarmEvent }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName  { return Enums.SimaxModuleName.Alarm }
    private static get LOG_STRING(): string { return '[SIMAX.Alarms.AlarmsHelper] - %s' }
    
    // Consts End


    // Methods

    public static getAlarmMessagesGridColumns(): ColumnModel[] {

        const alarmStatus: ColumnModel = new ColumnModel()
        const operator: ColumnModel = new ColumnModel()
        const transmissionType: ColumnModel = new ColumnModel()

        alarmStatus.idName = 'alarmStatus'
        alarmStatus.name = 'AlarmStatus'
        alarmStatus.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Status)
            
        operator.idName = 'operator'
        operator.name = 'Operator'
        operator.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operator)
    
        transmissionType.idName = 'transmissionType'
        transmissionType.name = 'TransmissionType'
        transmissionType.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TransmissionType) 

        return [alarmStatus, operator, transmissionType]
    }

    public static confirmAlarm(referenceObjectId, userSession): JQueryPromise<OpAlarmEvent[]> {
        return userSession.getDataProvider().AlarmEvent.confirmAlarmEvent(referenceObjectId).then((result: OpAlarmEvent[]) => {
            if (result != null) {
                if (result.length === 1) {
                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmApproved))
                } else {
                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmsApproved))
                }
            } else {
                ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                console.warn(AlarmHelper.LOG_STRING, `Unable to confirm alarm.`)
            }

            return result

        }).fail((error: any) => {

            const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

            ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            console.warn(AlarmHelper.LOG_STRING, `Unable to confirm alarm. Error: ${errorMsg}.`)
        })
    }
}